// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.yTCge{cursor:var(--truncate-text-cursor,default);display:inline-block;max-width:var(--truncate-text-max-width,100%);overflow:hidden;text-overflow:ellipsis;vertical-align:bottom;white-space:nowrap}.miCSK{display:-webkit-box;white-space:normal;-webkit-box-orient:vertical;-webkit-line-clamp:var(--truncate-text-lines,2)}.czpCF.ui.popup{max-width:30rem;overflow-wrap:anywhere}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"trigger": `yTCge`,
	"clamp": `miCSK`,
	"popup": `czpCF`
};
module.exports = ___CSS_LOADER_EXPORT___;
